import Vue from 'vue'
import App from './components/App.vue'
// Import all components here

Vue.component('App', App)
// Attach all components to Vue here



// WEBPACK FOOTER //
// ./src/components.js